import Vue from 'vue'
import Vuex from 'vuex'

import AuthModule from './modules/auth.js';
import ApiModule from './modules/api.js';
import CartModule from './modules/cart.js';
import CarModule from './modules/car.js';
import VoteModule from './modules/vote.js';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: AuthModule,
    api: ApiModule,
    cart: CartModule,
    car: CarModule,
    vote: VoteModule,
  },
  state: {
    storeBusy: [],
    errMsgs: [],
    windowWidth: 0,
    hideNav: false,
  },
  getters: {
    isStoreBusy(state) {
      return state.storeBusy.length > 0;
    },
    isMobileSize(state) {
      return state.windowWidth < 768;
    },
  },
  mutations: {
    APPENDBUSY(state, payload) {
      const index = state.storeBusy.indexOf(payload);
      if (index === -1) {
        state.storeBusy.push(payload);
      }
    },
    CLEARBUSY(state, payload) {
      const index = state.storeBusy.indexOf(payload);
      if (index !== -1) {
        state.storeBusy.splice(index, 1);
      }
    },
    APPENDERRORMSG(state, errMsg) {
      state.errMsgs.push(errMsg);
    },
    CLEARERRORMSG(state) {
      state.errMsgs.splice(0, state.errMsgs.length);
    },
    SETNAVHIDE(state, payload) {
      state.hideNav = payload;
    },
    SETWINDOWWIDTH(state, payload) {
      state.windowWidth = payload;
    },
  },
  actions: {
    appendComponentBusy(context, busyName) {
      context.commit("APPENDBUSY", busyName);
    },
    clearComponentBusy(context, busyName) {
      context.commit("CLEARBUSY", busyName);
    },
    showMsg(context, msg) {
      alert(msg);
    },
    appendErrorMsg(context, errMsg) {
      context.commit("APPENDERRORMSG", errMsg);
    },
  },
})
